import { Schema as n } from "prosemirror-model";
import { markSpecs as a } from "./specs/mark-specs.js";
import { nodeSpecs as s } from "./specs/node-specs.js";
class f {
  config;
  constructor(t) {
    this.config = t;
  }
  schema() {
    if (this.containsMultipleListTypes())
      throw new Error("schema should not have both nested and non-nested lists");
    return new n(this.schemaSpec);
  }
  containsMultipleListTypes() {
    const t = this.config.allowedBlocks, e = t.some((i) => this.isListType(i)), o = t.some((i) => this.isNestedListType(i));
    return e && o;
  }
  get schemaSpec() {
    return { nodes: this.nodes, marks: this.marks };
  }
  get nodes() {
    const t = {
      doc: s.doc,
      text: s.text,
      hardBreak: s.hardBreak,
      marker: s.marker
    };
    this.config.singleBlockMode && (t.doc = s.singleBlockDoc), this.config.templating && (t.template = s.template, t.template.infoResolver = this.config.templating.resolver), this.config.aiPromptData && (t.aiPromptData = s.aiPromptData, t.aiPromptData.infoResolver = this.config.aiPromptData.resolver, t.aiPromptData.commandsResolver = this.config.aiPromptData.commandsResolver), this.config.allowedBlocks.forEach((e) => {
      this.isListType(e) && !t.listItem ? t.listItem = s.listItem : e === "table" ? (t.tableRow = s.tableRow, t.tableCell = s.tableCell, this.config.tables.containers && (t.tableCell = {
        ...t.tableCell,
        content: "(block | list | table)+"
      })) : this.isNestedListType(e) ? t.nestedListItem = s.nestedListItem : e === "collapsibleSection" ? (t.collapsibleSectionSummary = s.collapsibleSectionSummary, t.collapsibleSectionContent = s.collapsibleSectionContent) : e === "imageText" && (t.imageText = s.imageText), t[e] = s[e];
    }), this.config.allowedInline.forEach((e) => {
      s[e] && (t[e] = s[e]);
    });
    for (const e of this.config.customBlockHandlers ?? [])
      t[e.type] = e.spec;
    for (const e of this.config.customInlineHandlers ?? [])
      t[e.name] = e.spec;
    return this.stripListIfNeeded(t), this.stripTableIfNeeded(t), t;
  }
  stripListIfNeeded(t) {
    if (t.orderedList || t.unorderedList || t.orderedNestedList || t.unorderedNestedList)
      return;
    const e = t.doc.content ?? "", o = /list\s*\|\s*/, i = /\s*\|\s*list/, r = e.replace(o, "").replace(i, "");
    t.doc = { ...t.doc, content: r };
  }
  stripTableIfNeeded(t) {
    if (t.table)
      return;
    const e = t.doc.content ?? "", o = /table\s*\|\s*/, i = /\s*\|\s*table/, r = e.replace(o, "").replace(i, "");
    t.doc = { ...t.doc, content: r };
  }
  isListType(t) {
    return t === "orderedList" || t === "unorderedList";
  }
  isNestedListType(t) {
    return t === "orderedNestedList" || t === "unorderedNestedList";
  }
  get marks() {
    const t = {};
    return this.config.allowedInline.forEach((e) => {
      a[e] && (t[e] = a[e]);
    }), t;
  }
}
export {
  f as SchemaGenerator
};
